import type { Node } from '~/types/file-tree';

/**
 * Compare function to sort a file list such that folders appears before files and
 * all items are sorted alphabetically within their level.
 */
export function compareFiles(fileA: Node, fileB: Node) {
  const segmentsA = fileA.fullPath.split('/');
  const segmentsB = fileB.fullPath.split('/');
  const minLength = Math.min(segmentsA.length, segmentsB.length);

  for (let i = 0; i < minLength; i++) {
    const a = toFileSegment(fileA, segmentsA, i);
    const b = toFileSegment(fileB, segmentsB, i);

    // folders are always shown before files
    if (a.type !== b.type) {
      return a.type === 'folder' ? -1 : 1;
    }

    const comparison = a.segment.localeCompare(b.segment);

    // if this is true then they are in different folders
    if (comparison !== 0) {
      return comparison;
    }
  }

  return fileA.fullPath.localeCompare(fileB.fullPath);
}

function toFileSegment(file: Node, segments: string[], index: number) {
  const isLast = index === segments.length - 1;

  return { segment: segments[index], type: isLast ? file.kind : 'folder' };
}
